import PropTypes from "prop-types";

export const TableTitleCellLinkAttributes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  modalState: PropTypes.object,
  inModal: PropTypes.bool,
};

export const TableTitleCellLinkType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape(TableTitleCellLinkAttributes),
]);
